/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_File_RequiredInputs */

const vi_error_file_required = /** @type {(inputs: Error_File_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thiếu file ảnh cần tải lên. Chọn file rồi thử lại.`)
};

/**

* @param {Error_File_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_file_required = /** @type {((inputs?: Error_File_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_File_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_file_required(inputs)
});